// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 538 ? "recorder" : chunkId) + "-legacy." + {"403":"7062456a","538":"d3555b05","554":"eafd992a"}[chunkId] + ".js";
};